export default __webpack_public_path__ + "static/media/rocket_anim_125.1d5056b9.png";